import {Component, inject, Input, OnInit} from '@angular/core';
import {PropertyDetails} from "../../../../../services/portal-api.service";
import {TranslocoDirective, TranslocoService} from "@jsverse/transloco";

@Component({
  selector: 'app-search-property-item',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './search-property-item.component.html',
  styleUrl: './search-property-item.component.css'
})
export class SearchPropertyItemComponent implements OnInit {
  @Input() property!: PropertyDetails;

  public activeLang: string = '';
  private translocoService = inject(TranslocoService);

  ngOnInit() {
    this.activeLang = this.translocoService.getActiveLang();
  }

}
